import React from 'react';
import { Space } from 'antd';
import { useTranslation } from 'react-i18next';

import { handleError } from 'app/utils/handle-error';
import { config } from 'app/config';

import styles from './top-bar.module.scss';

export const TopBar: React.FC = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className={styles.topBar}>
      <div className={styles.languages}>
        <Space size="middle">
          {config.availableLanguages.map((language) => (
            <span
              key={language}
              className={styles.languageButton}
              onClick={() => i18n.changeLanguage(language).catch(handleError)}
            >
              {t(`header.language.${language}`)}
            </span>
          ))}
        </Space>
      </div>
    </div>
  );
};
